import React from 'react';
import { Clock, MapPin } from 'lucide-react';

/** Compact shift card with track accent bar. */
export default function RosterShiftChip({ entry, accent, onClick, showLocation }) {
  return (
    <button
      type="button"
      onClick={() => onClick(entry)}
      className={`relative w-full text-left rounded-lg pl-2.5 pr-2 py-1.5 text-[11px] border transition hover:shadow-sm overflow-hidden ${
        entry.published
          ? 'bg-emerald-50 border-emerald-200 text-emerald-900'
          : 'bg-amber-50 border-amber-200 text-amber-900'
      }`}
      data-testid={`roster-shift-${entry.id}`}
    >
      <span
        className="absolute left-0 top-0 bottom-0 w-1"
        style={{ background: accent }}
        aria-hidden
      />
      <div className="font-semibold truncate">{entry.staff_name}</div>
      <div className="opacity-80 flex items-center gap-1 mt-0.5">
        <Clock className="h-3 w-3" /> {entry.shift_start}–{entry.shift_end}
      </div>
      {showLocation && entry.location ? (
        <div className="truncate mt-0.5 opacity-70 flex items-center gap-1">
          <MapPin className="h-3 w-3 shrink-0" /> {entry.location}
        </div>
      ) : entry.specialisation ? (
        <div className="truncate mt-0.5 opacity-70" style={{ color: accent }}>{entry.specialisation}</div>
      ) : null}
    </button>
  );
}
